import { render, staticRenderFns } from "./SelectCurrency.vue?vue&type=template&id=189841b2&"
import script from "./SelectCurrency.vue?vue&type=script&lang=ts&"
export * from "./SelectCurrency.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('189841b2')) {
      api.createRecord('189841b2', component.options)
    } else {
      api.reload('189841b2', component.options)
    }
    module.hot.accept("./SelectCurrency.vue?vue&type=template&id=189841b2&", function () {
      api.rerender('189841b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/select/SelectCurrency.vue"
export default component.exports